import { Box, Checkbox, Typography } from "@mui/material";

const options = [
  {
    label: "Loader Bucket",
    icon: "/assets/img/icons/tractor_b.svg",
    key: "has_loader_bucker",
  },
  {
    label: "3 Points Lift",
    icon: "/assets/img/icons/3pl_lift.svg",
    key: "has_3PL",
  },
  {
    label: "Power Streering",
    icon: "/assets/img/icons/pwr_str.svg",
    key: "has_power_steering",
  },
  {
    label: "Cabin",
    icon: "/assets/img/icons/cabin.svg",
    key: "has_cabin",
  },
  {
    label: "Heater",
    icon: "/assets/img/icons/heater.svg",
    key: "has_heater",
  },
  {
    label: "AC",
    icon: "/assets/img/icons/ac.svg",
    key: "has_ac",
  },
  {
    label: "PTO",
    icon: "/assets/img/icons/pto.svg",
    key: "has_pto",
  },
  {
    label: "4WD",
    icon: "/assets/img/icons/4wd.svg",
    key: "has_4wd",
  },
];
const MoreSection = ({ value, onChange }: { value?: any; onChange?: any }) => {
  return (
    <>
      <Box sx={{ px: "4%", py: "20px" }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "34px",
            color: "#2A2A2A",
          }}
        >
          More filters
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {options.map((r: any, i) => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img
                src={r.icon}
                style={{ marginBottom: "10px" }}
                width="24"
                height="24"
                alt=""
              />
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  width: "100%",
                  justifyContent: "space-between",
                  borderBottom:
                    i + 1 !== options.length ? "1px solid #E9E9E9" : "",
                  py: "10px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    lineHeight: "18px",
                    color: "#323232",
                  }}
                >
                  {r.label}
                </Typography>{" "}
                <Checkbox
                  checked={Boolean(value[r.key])}
                  onChange={({ target }) => {
                    if (target.checked) onChange({ ...value, [r.key]: true });
                    else onChange({ ...value, [r.key]: false });
                  }}
                  sx={{ padding: "0px" }}
                  checkedIcon={
                    <img src="/assets/img/icons/checked.svg" alt="" />
                  }
                  icon={<img src="/assets/img/icons/unchecked.svg" alt="" />}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Box sx={{ height: "8px", background: "#F7F7F7", width: "100%" }} />
      <Box sx={{ px: "4%", py: "20px" }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "34px",
            color: "#2A2A2A",
          }}
        >
          Additional Service Offered
        </Typography>

        <Box>
          <Box
            sx={{
              borderBottom: "1px solid #E9E9E9",
              py: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
            }}
          >
            <Typography
              sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "18px" }}
            >
              Delivery & Pickup
            </Typography>
            <Checkbox
              checked={value.delv_and_pickup}
              onChange={({ target }) =>
                onChange({ ...value, delv_and_pickup: target.checked })
              }
              sx={{ padding: "0px" }}
              checkedIcon={<img src="/assets/img/icons/checked.svg" alt="" />}
              icon={<img src="/assets/img/icons/unchecked.svg" alt="" />}
            />
          </Box>
          <Box
            sx={{
              py: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
            }}
          >
            <Typography
              sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "18px" }}
            >
              Operator Services Offered
            </Typography>
            <Checkbox
              checked={value.offer_operator_service}
              onChange={({ target }) =>
                onChange({ ...value, offer_operator_service: target.checked })
              }
              sx={{ padding: "0px" }}
              checkedIcon={<img src="/assets/img/icons/checked.svg" alt="" />}
              icon={<img src="/assets/img/icons/unchecked.svg" alt="" />}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default MoreSection;
